
import { useEffect, useState } from "react";
import { Container, Row, Col, Carousel } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBoxOpen, faTruck, faIndustry, faShieldAlt,
  faArrowRight, faCheckCircle, faPhone,
} from "@fortawesome/free-solid-svg-icons";
import CountUp from "react-countup";
import AOS from "aos";
import "aos/dist/aos.css";
import { Link } from "react-router-dom";
import "./Home.css";

import home  from "../assets/images/home.webp";
import ipm1  from "../assets/images/ipm-1.jpg";
import ipm2  from "../assets/images/ipm-2.jpeg";
// import ipm4  from "../assets/images/ipm-3.webp";
import ipm4 from "../assets/images/corrogatedboxandpallets.jpg";
import ipm3  from "../assets/images/manufact & supply-3.jpg";
import ipm5  from "../assets/images/Bubble Wrap Roll  Air Bubble Packaging Sheet.jpeg";
import ipm6  from "../assets/images/Corrugated Packaging Materials.jpeg";
import ipm7  from "../assets/images/Transparent Plastic Packaging Bags.jpeg";
import ipm8  from "../assets/images/Plastic Strapping Rolls.jpeg";
import ipm9  from "../assets/images/Wooden Pallets.jpeg";
import ipm10 from "../assets/images/Protective Packaging Made from Foam.webp";
import ipm11 from "../assets/images/Amcon Foam.jpg";
import ipm12 from "../assets/images/Packing Foam.webp";
import ipm13 from "../assets/images/eva-foam-packaging-tray.webp";
import ipm14 from "../assets/images/epe-foam-buffer.webp";
import ipm15 from "../assets/images/foam packing tray.webp";
// import ipm16 from "../assets/images/Foam Sheets.jpg";
import ipm16 from "../assets/images/ipm-4.jpg";


import ms1   from "../assets/images/manufacture & supply-1.jpg";
import ms2   from "../assets/images/manufacture & supply-2.jpg";
import ms3   from "../assets/images/manufact & supply-3.jpg";
import foam1 from "../assets/images/customized-epe-foam-fitment.jpg";
import foam2 from "../assets/images/customized-epe-foam-tray.jpg";
import foam3 from "../assets/images/customized-high-density-foam-tray.jpg";
import foam4 from "../assets/images/epe-foam-profile.jpg";
import foam5 from "../assets/images/foam-fabricated-parts.jpg";
// import foam6 from "../assets/images/pu-foam-gasket.jpg";
import foam6 from "../assets/images/esdpackagingmaterial.png";
import foam7 from "../assets/images/customized-eva-packaging-foam.jpg";
import foam8 from "../assets/images/customized-self-adhesive-foam-tape.jpg";
import foam9 from "../assets/images/white-epe-foam-bracket.jpg";
import hero4 from "../assets/images/about-us.jpg";
import stretchfilmstowoodenpallets from "../assets/images/stretchfilmstowoodenpallets.jpg";
import CompletePackagingRange from "../assets/images/CompletePackagingRange.jpg";
import IndustrialPackagingSolutions from "../assets/images/IndustrialPackagingSolutions.jpg";
import IndustrialPackagingSupply from "../assets/images/IndustrialPackagingSupply.jpg";

const Home = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    AOS.init({ duration: 900, once: true, easing: "ease-out-cubic" });

    const handleScroll = () => {
      if (window.scrollY > 300) setIsVisible(true);
    };
    const handleResize = () => setWindowWidth(window.innerWidth);

    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleResize);
    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  /* Hero slides */
  const heroSlides = [
    { image: IndustrialPackagingSolutions,  title: "Industrial Packaging Solutions",  sub: "Trusted manufacturer & supplier in Pune — serving 500+ industries" },
    { image: stretchfilmstowoodenpallets,  title: "Stretch Film & Bubble Roll",      sub: "Premium quality stretch films and air bubble rolls for every industry" },
    { image: CompletePackagingRange, title: "Complete Packaging Range",        sub: "From stretch films to wooden pallets — all under one roof" },
  ];

  /* Featured products */
  const featuredProducts = [
    // { image: ipm10, name: "Protective Foam Packaging",           desc: "High-density foam cushions that protect fragile items from shock and damage during transit." },
    { image: ipm11, name: "Protective Foam Packaging",                          desc: "Premium quality Amcon foam offering superior cushioning for safe and protective packaging." },
    { image: ipm12, name: "Packing Foam",                        desc: "Versatile packing foam providing excellent cushioning to protect items from shock and impact." },
    { image: ipm13, name: "EVA Foam Packaging Tray",             desc: "Durable EVA foam trays offering precise protection and cushioning for delicate components." },
    { image: ipm14, name: "EPE Foam Buffer Box",                 desc: "Shock-absorbing EPE foam buffer boxes for safe storage and transport of sensitive products." },
    { image: ipm15, name: "Foam Packing Tray",                   desc: "Custom foam packing trays that safely hold and cushion items during storage and shipping." },
    { image: ipm16, name: "Foam Sheets or Foam Roll",                         desc: "Soft foam sheets providing excellent cushioning to protect items from scratches and impact." },
    { image: ipm1,  name: "Stretch Film & Bubble Roll",          desc: "High-quality stretch films and air bubble rolls for safe, secure product packaging." },
    { image: ipm2,  name: "BOPP & Printed Tape",                 desc: "Durable BOPP tapes and custom printed tapes for all industrial packaging needs." },
    { image: ipm3,  name: "Lashing & Cargo Straps",              desc: "Ratchet belts, cargo lashing belts and truck lashing straps for secure transport." },
    { image: ipm4,  name: "Corrugated Boxes & Pallets",          desc: "Strong corrugated boxes, wooden boxes and FLC box pallets for industrial storage." },
    { image: ipm5,  name: "Bubble Wrap Roll",                    desc: "Protective, lightweight bubble wrap rolls for safe packaging and shipping of goods." },
    { image: ipm6,  name: "Corrugated Packaging Materials",      desc: "Heavy-duty corrugated sheets and rolls for strong, protective industrial packaging." },
    { image: ipm7,  name: "Transparent Plastic Packaging Bags",  desc: "Lightweight poly bags to protect items from dust, moisture and damage during storage." },
    { image: ipm8,  name: "PP / PET Strapping Rolls",            desc: "Strong plastic strapping rolls for bundling and securing heavy packages safely." },
    { image: ipm9,  name: "Wooden Pallets",                      desc: "Sturdy wooden platforms for safe storage and transportation of industrial goods." },
  ];

  /* Foam products */
  const foamProducts = [
    { image: foam1, name: "EPE Foam Fitment",        desc: "Custom-cut EPE foam fitments for precise product protection inside packaging." },
    { image: foam2, name: "EPE Foam Tray",           desc: "Precision-cut EPE foam trays for safe component packaging and storage." },
    { image: foam3, name: "HD Foam Tray",            desc: "High-density foam trays for heavy-duty industrial packaging applications." },
    { image: foam4, name: "EPE Foam Profile",        desc: "EPE foam profiles for edge and corner protection of packaged goods." },
    { image: foam5, name: "Foam Fabricated Parts",   desc: "Custom fabricated foam parts cut to any shape or size requirement." },
    // { image: foam6, name: "PU Foam Gasket",          desc: "PU foam gaskets for sealing, vibration damping and cushioning applications." },
    { image: foam6, name: "ESD Packaging Materials",          desc: "ESD packaging materials protect electronic components from static electricity damage." },
    { image: foam7, name: "EVA Packaging Foam",      desc: "Lightweight EVA foam for durable, flexible packaging solutions." },
    { image: foam8, name: "Self Adhesive Foam Tape", desc: "Self-adhesive foam tape for sealing, cushioning and gap-filling applications." },
    { image: foam9, name: "White EPE Foam Bracket",  desc: "White EPE foam brackets for corner and edge protection of products." },
  ];

  /* Manufacturer & Supplier grid */
  const supplyGrid = [
    { image: IndustrialPackagingSupply,   label: "Industrial Packaging Supply",          sub: "Stretch films, bubble rolls, foam sheets for all industries" },
    { image: ms2,   label: "Strapping & Lashing Solutions",        sub: "PP strap, PET strap, ratchet belts, cargo lashing" },
    { image: ipm10, label: "Protective Foam Packaging",            sub: "Foam cushions protect fragile items from shock and damage" },
    { image: ipm11, label: "Amcon Foam",                           sub: "High-quality cushioning foam for safe protective packaging" },
    { image: ipm12, label: "Packing Foam",                         sub: "Cushioning foam to protect items from shock and damage" },
    { image: ipm13, label: "EVA Foam Packaging Tray",              sub: "Durable cushioning and precise protection for delicate items" },
    { image: ipm14, label: "EPE Foam Buffer Box",                  sub: "Shock-absorbing protection for safe storage and transport" },
    { image: ipm15, label: "Foam Packing Tray",                    sub: "Safely holds and cushions items during storage and shipping" },
    { image: ipm16, label: "Foam Sheets",                          sub: "Soft cushioning to protect items from scratches and impact" },
    { image: ipm1,  label: "Stretch Film & Bubble Roll",           sub: "High-quality stretch films and air bubble rolls" },
    { image: ipm2,  label: "BOPP & Printed Tape",                  sub: "Durable BOPP and custom printed tapes for packaging" },
    { image: ipm3,  label: "Lashing & Cargo Straps",               sub: "Ratchet belts and cargo lashing straps for secure transport" },
    { image: ipm4,  label: "Corrugated Boxes & Pallets",           sub: "Corrugated boxes, wooden boxes and pallets for storage" },
    { image: ipm5,  label: "Bubble Wrap Roll",                     sub: "Lightweight bubble wrap for safe packaging and shipping" },
    { image: ipm6,  label: "Corrugated Packaging Materials",       sub: "Strong corrugated sheets and rolls for protective packaging" },
    { image: ipm7,  label: "Transparent Plastic Packaging Bags",   sub: "Lightweight poly bags to protect items from dust and moisture" },
    { image: ipm8,  label: "PP / PET Strapping Rolls",             sub: "Strong straps for bundling and securing packages safely" },
    { image: ipm9,  label: "Wooden Pallets",                       sub: "Strong platforms for storing and transporting goods safely" },
  ];

  const chunk = (arr, size) =>
    Array.from({ length: Math.ceil(arr.length / size) }, (_, i) => arr.slice(i * size, i * size + size));

  const chunkSize = windowWidth < 576 ? 1 : windowWidth < 992 ? 2 : 4;
  const featuredChunks = chunk(featuredProducts, chunkSize);

  return (
    <div className="home-page">

      {/* ══ HERO CAROUSEL ══ */}
      <section className="hero-section">
        <Carousel fade interval={4500} className="hero-carousel" controls indicators>
          {heroSlides.map((slide, i) => (
            <Carousel.Item key={i}>
              <div className="hero-slide" style={{ backgroundImage: `url(${slide.image})` }}>
                <div className="hero-overlay">
                  <Container>
                    <div className="hero-content text-center">
                      <span className="hero-badge">Industrial Packaging</span>
                      <h1 className="hero-title">{slide.title}</h1>
                      <p className="hero-sub">{slide.sub}</p>
                      <div className="hero-btns justify-content-center">
                        <Link to="/products" className="btn-hero-primary">
                          View Products <FontAwesomeIcon icon={faArrowRight} className="ms-2" />
                        </Link>
                        <Link to="/contact" className="btn-hero-outline">
                          <FontAwesomeIcon icon={faPhone} className="me-2" /> Get a Quote
                        </Link>
                      </div>
                    </div>
                  </Container>
                </div>
              </div>
            </Carousel.Item>
          ))}
        </Carousel>
      </section>

      {/* ══ ABOUT STRIP ══ */}
      <section className="about-strip">
        <Container>
          <Row className="align-items-center">
            <Col md={8} data-aos="fade-right">
              <h2 className="strip-title">Anvika Industrial Supplier</h2>
              <p className="strip-text">
                A trusted <strong>manufacturer & supplier</strong> of industrial packaging materials based in Pune.
                We serve <strong>500+ clients</strong> across manufacturing, logistics, and export industries with quality products and on-time delivery.
              </p>
            </Col>
            <Col md={4} className="text-center text-md-end mt-3 mt-md-0" data-aos="fade-left">
              <Link to="/about" className="btn-strip">
                Know More <FontAwesomeIcon icon={faArrowRight} className="ms-2" />
              </Link>
            </Col>
          </Row>
        </Container>
      </section>

      {/* ══ STATS SECTION ══ */}
      <section className="stats-section">
        <Container>
          <Row>
            {[
              { end: 500, suffix: "+", label: "Happy Clients",         delay: 0 },
              { end: 200, suffix: "+", label: "Products Supplied",     delay: 100 },
              { end: 10,  suffix: "+", label: "Years Experience",      delay: 200 },
              { end: 99,  suffix: "%", label: "Customer Satisfaction", delay: 300 },
            ].map((s, i) => (
              <Col md={3} sm={6} key={i} className="stat-item" data-aos="zoom-in" data-aos-delay={s.delay}>
                <div className="stat-card">
                  <div className="stat-number">
                    {isVisible ? <CountUp end={s.end} duration={2.5} /> : "0"}{s.suffix}
                  </div>
                  <div className="stat-label">{s.label}</div>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* ══ FEATURED PRODUCTS CAROUSEL ══ */}
      <section className="products-carousel-section">
        <Container>
          <h2 className="section-title text-center" data-aos="fade-up">Featured Products</h2>
          <p className="section-sub text-center" data-aos="fade-up">
            Complete range of industrial packaging materials — manufactured and supplied across Pune and India.
          </p>
        </Container>
        <div className="prod-carousel-wrap" data-aos="fade-up" data-aos-delay="100">
          <Carousel interval={3500} indicators controls className="prod-carousel">
            {featuredChunks.map((group, gi) => (
              <Carousel.Item key={gi}>
                <div className="prod-carousel-row">
                  {group.map((p, pi) => (
                    <div className="prod-carousel-card" key={pi}>
                      <div className="pcc-img-wrap">
                        <img src={p.image} alt={p.name} />
                      </div>
                      <div className="pcc-body">
                        <h4>{p.name}</h4>
                        <p>{p.desc}</p>
                        <Link to="/products" className="pcc-link">
                          View Details <FontAwesomeIcon icon={faArrowRight} />
                        </Link>
                      </div>
                    </div>
                  ))}
                </div>
              </Carousel.Item>
            ))}
          </Carousel>
        </div>
      </section>

      {/* ══ WHY CHOOSE US ══ */}
      <section className="why-section">
        <Container>
          <h2 className="section-title text-center" data-aos="fade-up">Why Choose Us?</h2>
          <p className="section-sub text-center" data-aos="fade-up">We deliver quality, reliability, and value — every time.</p>
          <Row className="mt-4">
            {[
              { icon: faBoxOpen,   title: "Wide Product Range",      text: "From stretch films to wooden pallets — all industrial packaging needs under one roof.", delay: 0 },
              { icon: faIndustry,  title: "Manufacturer & Supplier", text: "Direct manufacturer of PP sheets, PP boxes, foam products, and more.", delay: 100 },
              { icon: faTruck,     title: "Reliable Delivery",       text: "Timely supply of packaging materials to industries across Pune and beyond.", delay: 200 },
              { icon: faShieldAlt, title: "Quality Assured",         text: "All products meet industrial standards — durable, reliable, and cost-effective.", delay: 300 },
            ].map((f, i) => (
              <Col lg={3} md={6} key={i} data-aos="fade-up" data-aos-delay={f.delay}>
                <div className="why-card">
                  <div className="why-icon"><FontAwesomeIcon icon={f.icon} /></div>
                  <h3>{f.title}</h3>
                  <p>{f.text}</p>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* ══ MANUFACTURER & SUPPLIER — IMAGE GRID ══ */}
      <section className="supply-grid-section">
        <Container>
          <h2 className="section-title text-center" data-aos="fade-up">Manufacturer & Supplier</h2>
          <p className="section-sub text-center" data-aos="fade-up">Serving industries across Pune with quality packaging materials</p>
          <div className="supply-grid">
            {supplyGrid.map((item, i) => (
              <div className="supply-grid-card" key={i} data-aos="fade-up" data-aos-delay={(i % 3) * 80}>
                <div className="sgc-img">
                  <img src={item.image} alt={item.label} />
                  <div className="sgc-overlay">
                    <FontAwesomeIcon icon={faCheckCircle} className="sgc-icon" />
                    <p className="sgc-sub">{item.sub}</p>
                  </div>
                </div>
                <div className="sgc-label">{item.label}</div>
              </div>
            ))}
          </div>
        </Container>
      </section>

      {/* ══ CUSTOMIZED FOAM PRODUCTS — FLIP CARD GRID ══ */}
      <section className="foam-section">
        <Container>
          <h2 className="section-title text-center" data-aos="fade-up">Customized Foam Products</h2>
          <p className="section-sub foam-sub text-center" data-aos="fade-up">EPE, EVA, PU foam — custom shapes, sizes, and densities. Hover to explore.</p>
          <div className="foam-grid">
            {foamProducts.map((p, i) => (
              <div className="foam-flip-card" key={i} data-aos="zoom-in" data-aos-delay={(i % 3) * 70}>
                <div className="foam-flip-inner">
                  <div className="foam-flip-front">
                    <img src={p.image} alt={p.name} />
                    <div className="foam-front-label">{p.name}</div>
                  </div>
                  <div className="foam-flip-back">
                    <h4>{p.name}</h4>
                    <p>{p.desc}</p>
                    <Link to="/material" className="foam-back-link">
                      View Details <FontAwesomeIcon icon={faArrowRight} />
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </Container>
      </section>

      {/* ══ CTA BANNER ══ */}
      <section className="cta-section" data-aos="fade-up">
        <div className="cta-inner">
          <h2>Ready to Order Industrial Packaging?</h2>
          <p>Get in touch for bulk orders, custom requirements, or product inquiries. We deliver across Pune and India.</p>
          <div className="cta-btns">
            <Link to="/contact" className="btn-cta-primary">
              <FontAwesomeIcon icon={faPhone} className="me-2" /> Contact Us
            </Link>
            <Link to="/products" className="btn-cta-outline">Browse Products</Link>
          </div>
        </div>
      </section>

    </div>
  );
};

export default Home;